export const CategoryOptionType = {
  B: 'B',
  K: 'K',
};
export const CategoryOption = [
  { value: CategoryOptionType.B, label: 'Előzetesen felszámított ÁFA' },
  { value: CategoryOptionType.K, label: 'Fizetendő ÁFA' },
];

export const AreaOption = [
  { value: 'BE', label: 'Belföld' },
  { value: 'EU', label: 'EU-n belül' },
  { value: 'EK', label: 'EU-n kívül' },
  { value: 'BEKU', label: 'Belföld/külföld' },
  { value: 'EUEK', label: 'EU-n belül/EU-n kívül' },
];

export const SubjectOptionValues = {
  T: 'T',
  S: 'S',
  TS: 'TS',
};

export const SubjectOption = [
  { value: SubjectOptionValues.T, label: 'Termék' },
  { value: SubjectOptionValues.S, label: 'Szolgáltatás' },
  { value: SubjectOptionValues.TS, label: 'Termék/szolgáltatás' },
];

export const TypeOption = [
  { value: 'Általános', label: 'Általános' },
  { value: 'Adómentes', label: 'Adómentes' },
  { value: 'Belföldi fordított adózás', label: 'Belföldi fordított adózás' },
  { value: 'Különbözet szerinti adózás', label: 'Különbözet szerinti adózás' },
  { value: 'Áfa törvény hatályán kívüli', label: 'Áfa törvény hatályán kívüli' },
];
